import { render } from "./Vip.vue?vue&type=template&id=417ece8a&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"

import "./Vip.vue?vue&type=style&index=0&id=417ece8a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417ece8a"]])

export default __exports__